import { msg } from "../../i18n/messages"
import { defineDirective } from "../../utils/angular"
import { IBasemap, IBasemapGroup, ILayer, IMapContainer, IMapContainerUserOptions, IMapLabelOptions } from "../types"

/** @internal */
export class MapOptionsCtrl {

    static create() {

        return defineDirective(MapOptionsCtrl, "shared/map/options/options.html", { map: "=" })

    }

    map: IMapContainer

    private _options: IMapContainerUserOptions
    public labels: IMapLabelOptions

    private _basemapGroups: IBasemapGroup[]

    static $inject = ["$scope"]

    constructor(private $scope: ng.IScope) {
    }

    $onInit() {

        const options = this._options = this.map.getUserOptions()

        const { labels, basemaps, additionalBasemaps } = options
        this.labels = labels
            ? { ...labels }
            : { declutter: true, deduplicate: true }
        this._basemapGroups = (additionalBasemaps ?? []).concat(basemaps).filter(i => !!i)

    }

    getLayers(): ILayer[] {
        return this._options.baseLayers
    }

    get basemapGroups() {
        return this._basemapGroups
    }

    filterBasemap() {
        return (group: IBasemapGroup) => this.map ? this.map.isBasemapAvailable(group) : true
    }

    hasContextLayers(): boolean {
        return this._options && this._options.contextLayers && (this._options.contextLayers.length > 0)
    }

    getContextLayers(): ILayer[] {
        return this._options.contextLayers
    }

    canDeduplicateLabels() {
        return this._options.canDeduplicateLabels
    }

    get dontDeduplicate() {
        return this.labels && !this.labels.deduplicate
    }

    set dontDeduplicate(value: boolean) {
        this.labels.deduplicate = !value
    }

    viewBasemap(basemap: IBasemap) {
        this.map.viewExtent(basemap.getExtent())
    }

    canSetLabelOptions() {
        // Note: the only option remaining is the one used to disable label deduplication,
        // so the whole section must be disabled if this one also is
        return this.map && this.map.canSetLabelOptions() && this.canDeduplicateLabels()
    }

    updateLabelOptions() {
        this.map.setLabelOptions({ ...this.labels })
    }

    onVisibilityChanged(target: ILayer | IBasemapGroup) {
        this.map?.onVisibilityChanged(target)
    }

    close() {
        var item = this.$scope.$parent["popupContext"]
        item.open = false
    }

    getLabelsToolip(l: ILayer) {
        return l.showLabels ? msg("Hide labels") : msg("Show labels")
    }

}
